class SpecificationsTabs extends HTMLElement {
  tablist = null;
  tabs = [];
  panels = [];

  connectedCallback() {
    this.tablist = this.querySelector('[role="tablist"]');

    if (!this.tablist) return;

    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.tablist.addEventListener('click', this.onClick);
    this.tablist.addEventListener('keydown', this.onKeydown);
  }

  onClick = (event) => {
    const tab = event.target.closest('[role="tab"]');

    if (!tab) return;

    this.select(this.tabs.indexOf(tab));
  };

  onKeydown = (event) => {
    const current = this.tabs.indexOf(document.activeElement);

    if (current === -1) return;

    let next = null;

    switch (event.key) {
      case 'ArrowRight':
        next = (current + 1) % this.tabs.length;
        break;
      case 'ArrowLeft':
        next = (current - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = this.tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.select(next);
    this.tabs[next].focus();
  };

  select(index) {
    this.tabs.forEach((tab, i) => {
      const selected = i === index;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
      this.panels[i].hidden = !selected;
    });

    // Scroll only the tablist — scrollIntoView would also scroll the page vertically
    const tab = this.tabs[index];
    const delta = tab.getBoundingClientRect().left - this.tablist.getBoundingClientRect().left;
    this.tablist.scrollTo({
      left: this.tablist.scrollLeft + delta - (this.tablist.clientWidth - tab.offsetWidth) / 2,
      behavior: 'smooth',
    });
  }
}

customElements.define('specifications-tabs', SpecificationsTabs);
